export default "__VITE_ASSET__06ZEFJy3__"